import React from "react";
import {Form, Select, Input, InputNumber,Radio,Switch,DatePicker} from 'antd';
import NHFormItem from '../../common/NHFormItem/index';
import NHSelect from "../../common/NHSelect";
import moment from 'moment';
import NHUeditor from "../../common/NHUeditor";
import NHFetch from "../../../utils/NHFetch";
import {message } from 'antd';
const {TextArea} = Input;

const FormItem = Form.Item;
const baseUrlPath = "/fwwgl/zzbd";

class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
           hjlxTmep:''
        }
    }

    componentDidMount(){
        let data  = this.props.initFormData;
        if(data && data.hjlx && data.hjlx == 2){
            this.setState({hjlxTmep : 2});
        }
    }

    onChange =(e) => {
        this.setState({hjlxTmep : e.target.value})
    }

    //获取设置富文本编辑器的方法
    setPcbltsEditor=(editor)=>{
        const {initFormData} = this.props;
        let nr =initFormData?initFormData.pcblts:'';
        if(nr){
            editor.setContent(nr);
        }
        this.setState({loading:false});
    }

    //获取设置富文本编辑器的方法
    setYdbltsEditor=(editor)=>{
        const {initFormData} = this.props;
        let nr = initFormData?initFormData.ydblts:'';
        if(nr){
            editor.setContent(nr);
        }
        this.setState({loading:false});
    }

    getDisabledData = (e) => {
        NHFetch(baseUrlPath + "/getDisabledData", "GET", { hjdm: e })
        .then(res => {
            if (res && res.data===1) {
                message.warning("该环节代码已存在，请选择其他环节代码！");
                this.props.form.setFieldsValue({hjdm:''})
            }
            
        });
    }
    
    render() {       
        const {form, initFormData} = this.props;
        const {setFieldsValue} = this.props.form;
        return (
            <div>
                <Form layout="horizontal">
                <NHFormItem id={'hjmc'} label={'环节名称'} hasFeedback={true} form={form} required={true}  whitespace={true}
                            pattern={{max: 100, message: "流程名称长度不能超过100字符！"}}
                            initialValue={initFormData ? initFormData.hjmc : ''}>
                    <Input placeholder="请输入环节名称"/>
                </NHFormItem>
                <NHFormItem id={'hjlx'} label={'环节类型'} form={form} required={true}
                            initialValue={initFormData ? initFormData.hjlx:'1'}>                       
                    <Radio.Group onChange={this.onChange}>
                        <Radio value={"1"}>固定环节</Radio>
                        <Radio value={"2"}>自定义环节</Radio>
                    </Radio.Group>
                </NHFormItem> 
                {
                    this.state.hjlxTmep != 2  && 
                    <NHFormItem id={'hjdm'} label={'环节代码'} form={form} required={true}
                        initialValue={initFormData ? initFormData.hjdm:''} >                       
                        <NHSelect style={{ margin: '-5px 0', width: '100%' }} sign="DMK_YXXT_ZZBD_GDHJDM" onChange={this.getDisabledData}/>                               
                    </NHFormItem> 
                    }
                <NHFormItem id={'glhjid'} label={'关联环节'} form={form}
                        initialValue={initFormData ? initFormData.glhjid:''}>                       
                        <NHSelect style={{ margin: '-5px 0', width: '100%' }} sign="zhxg_yxxt_lcgl_hjxx"/>                      
                                  
                </NHFormItem> 
                <NHFormItem id={'khdlx'} label={'客户端显示'} form={form} required={true}
                        initialValue={initFormData ? initFormData.khdlx:''}>                       
                        <NHSelect style={{ margin: '-5px 0', width: '100%' }} sign="DMK_YXXT_KFDLX"/>                      
                                  
                </NHFormItem>

                <NHFormItem id={'pcblts'} label={'PC端办理提示'} hasFeedback={true} form={form}>
                       {/* <TextArea placeholder="请输入100字以内的环节描述" rows={3}/>*/}
                       <NHUeditor width={'770px'} id={"pcblts"}  Editor={this.setPcbltsEditor} getContent={this.props.getPcbltsContent} />
                </NHFormItem>

                <NHFormItem id={'ydblts'} label={'移动端办理提示'} hasFeedback={true} form={form}
                            initialValue={initFormData ? initFormData.ydblts : ''}>
                   {/* <TextArea placeholder="请输入100字以内的环节描述" rows={3}/>*/}
                        <NHUeditor width={'770px'} id={"ydblts"}  Editor={this.setYdbltsEditor} getContent={this.props.getYdbltsContent}  />
                </NHFormItem>

                <NHFormItem id={'kssj'} label={'开始时间'} form={form} required={true}
                                initialValue={initFormData ? moment(initFormData.kssj) : ''}>
                    <DatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="开始时间"
                    />
                </NHFormItem>
                <NHFormItem id={'jssj'} label={'结束时间'} form={form} required={true}
                                initialValue={initFormData ? moment(initFormData.jssj) : ''}>
                    <DatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="结束时间"
                    />
                </NHFormItem>

                <NHFormItem id={'zt'} label={'流程状态'} form={form} valuePropName={'checked'}
                            required={true}
                            initialValue={initFormData ? (initFormData.zt == '1'?true:false):true}>
                    <Switch checkedChildren="启用" unCheckedChildren="停用"/>
                </NHFormItem>      

                <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initFormData ? initFormData.pxh : 1}>
                        <InputNumber/>
                </NHFormItem>                                
            </Form>
            </div>
        );
    }
}


const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/zzbd/EditForm.js